import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable, of } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { AgreementStatus } from '../models/enum/agreement.enum'
import { DispenserAgreementService } from '../services/agreement/dispenser/dispenser-agreement.service'
@Injectable({
  providedIn: 'root'
})
export class DispenserAgreementStatusGuard  {
  constructor(
    private dispenserAgreementService: DispenserAgreementService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const dispenserAgreementCode = route.url[route.url.length - 1].path

    if (isNaN(Number(dispenserAgreementCode))) {
      this.navigateToDispenserAgreements
    }

    return this.dispenserAgreementService.getAgreementDetail(dispenserAgreementCode).pipe(
      switchMap((agreementDetail) => of(agreementDetail)),
      map((detail) => {
        const canNavigate = detail.state === AgreementStatus.ACCEPTED
        if (canNavigate) {
          return true
        } else {
          this.navigateToDispenserAgreements
        }
      })
    )
  }

  private get navigateToDispenserAgreements() {
    return this.router.navigate(['/my-account/dispenserAgreements'])
  }
}
